import { useEffect, useRef } from "react";

const ButtonCustom = ({ classnames = "", onClick, type = "", children, style = {}, popOver = "" }) => {
  const popoverRef = useRef(null);

  const handleClick = (e) => {
    if (popoverRef.current) {
      window.$(popoverRef.current).popover("hide");
    }
    if (onClick) {
      onClick(e);
    }
  };
  
  useEffect(() => {
    if (popoverRef.current) {
      
      window.$(popoverRef.current).popover({
        trigger: 'hover'
      });
    }
    return () => {
      if (popoverRef.current) {
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
        window.$(popoverRef.current).popover("dispose");
      }
    };
  }, []);  

  return (
    <button
      ref={popoverRef}
      className={classnames}
      onClick={handleClick}
      type={type}
      style={style}
      data-content={popOver}
      data-placement="top"
    >
      {children}
    </button>
  );
};

export default ButtonCustom;
